import { type UserRolesTypes, type UserStatus } from './users';

export enum ClientStatus {
  ACTIVE = 'active',
  INVITED = 'invited',
  INACTIVE = 'inactive',
  DEACTIVATED = 'deactivated',
  BLOCKED = 'blocked',
  ARCHIVED = 'archived',
}

export interface ClientUser {
  company: string;
  deviceProfileIds: string[];
  email: string;
  firstName: string;
  id: string;
  isArchived: boolean;
  isDisabled: boolean;
  lastLogin?: string;
  lastName: string;
  name: string;
  notificationsPreferences: {
    emailEnabled: boolean;
    smsEnabled: boolean;
  };
  notificationTemplateId: string;
  phone: {
    countryCode: string;
    countryNumberCode: string;
    number: string;
    smsOptIn: boolean;
  };
  role: {
    id: string;
    name: UserRolesTypes;
  };
  roleId?: string;
  status: UserStatus;
  totpEnabled?: boolean;
  userPasswordPolicyId: '8009b138-6a61-4e12-85cc-7842b110acda';
}

// TODO: Merge UserClient and ChildClient interfaces once the backend API structure is unified.
export interface UserClient {
  clientName: string;
  clientShortName: string;
  description: string;
  friendlyName: string;
  id: string;
  isManagingClient: boolean;
  requireTotp?: boolean;
  roleId: string;
  status: ClientStatus;
  twoWayCommunication: boolean;
}

export interface ChildClient {
  appId: null | string;
  clientId: string;
  clientName: string;
  clientUserSettings?: {
    userSessionTimeoutMinutes: number;
  };
  createdOn: string;
  description: string | null;
  deviceProfileIds?: string[];
  friendlyName: string;
  id: string;
  internalClientCode: string;
  isArchived: boolean;
  isDisabled: boolean;
  isManagingClient: boolean;
  libraryAccessList: [
    {
      access: string;
      libraryId: string;
      ownerClientId: string;
    }
  ];
  requireTotp?: boolean;
  requireTotpSince?: string | null;
  shortName: string;
  status: ClientStatus;
  tags: {
    [key: string]: string;
  };
  tenantId: null | string;
  twoWayCommunication: boolean;
}
